import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-influsim',
  templateUrl: './influsim.component.html',
  styleUrls: ['./influsim.component.scss']
})
export class InflusimComponent implements OnInit {

  exposition: CardContent = {
    title: 'InfluSim',
    subtitle: 'A pandemic influenza preparedness planning tool',
    image_source: 'assets/images/InfluSim-2.6.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Partners</h4>University of Tübingen,<br>LGA Stuttgart',
      '<h4>Methods</h4>Deterministic Compartmental Modelling',
      '<h4>Technology / Skills</h4>Java, Swing, RK4',
      '<h4>Term</h4>2005 - 2009',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }



}
